import { AuthStateRootModel } from '../store/models';

export function getCombinedId(state: AuthStateRootModel) {
  if (state && state.user && state.company) {
    return `${state.user.id}__${state.company.id}`;
  }
  return null;
}
